export default __webpack_public_path__ + "static/media/circles.e7583734.svg";